function Header() {
  return (
    <div>
      <strong>Known issues:</strong> <br />
      Search buttons may be a little misaligned on smaller screens.
      <br />
      Bar charts go off of the screen on mobile. They are still accessible but
      require scrolling right and going off of the page.
    </div>
  );
}

export default Header;
